import { Form, Input, Grid, Select, DatePicker2, Field } from "@alifd/next";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import MD5 from 'crypto-js/md5';
import Base64 from 'crypto-js/enc-base64';

const AddUser = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, ...otherProps } = props;
    const [dataSource, setDataSource] = useState({});
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));

    useEffect(() => {
        fieldRef.current.reset();
        fieldRef.current.setValues({ Gender: 0, State: 'AC', Language: 'zh-CN' });
    }, []);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                result.Password = Base64.stringify(MD5(`${result.UserId.toLowerCase()}@${result.Password}`));
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, []);
    return (
        <Form field={fieldRef.current} className="bef-custom-user">
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item required label="用户编号" name="UserId" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="用户名" name="UserName" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item required label="用户密码" name="Password" className="custom-form-control">
                        <Input.Password />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item label="性别" name="Gender" className="custom-form-control">
                        <Select style={{ width: '100%' }} >
                            <Select.Option value={0}>女</Select.Option>
                            <Select.Option value={1}>男</Select.Option>
                        </Select>
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="出生日期" name="Birthday" className="custom-form-control">
                        <DatePicker2 style={{ width: '100%' }} />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="语言" name="Language" className="custom-form-control">
                        <Select style={{ width: '100%' }} >
                            <Select.Option value="zh-CN">中文</Select.Option>
                            <Select.Option value="en-US">英文</Select.Option>
                        </Select>
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item required label="状态" name="State" className="custom-form-control">
                        <Select style={{ width: '100%' }} >
                            <Select.Option value="AC">激活</Select.Option>
                            <Select.Option value="LC">锁定</Select.Option>
                            <Select.Option value="DL">删除</Select.Option>
                            <Select.Option value="RP">重置</Select.Option>
                        </Select>
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="生效日期" name="ValidateDate" className="custom-form-control">
                        <DatePicker2 style={{ width: '100%' }} />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="失效日期" name="ExpireDate"className="custom-form-control">
                        <DatePicker2 style={{ width: '100%' }} />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col>
                    <Form.Item label="邮箱" name="Email" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="手机号码" name="PhoneNumber" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="办公电话" name="TelNumber" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="24">
                <Grid.Col span={8}>
                    <Form.Item label="身份证件号码" name="IdentityNumber" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col span={16}>
                    <Form.Item label="地址" name="Address" className="custom-form-control">
                        <Input />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
        </Form>
    );
});
export default AddUser;